import { render, staticRenderFns } from "./Edit-User.vue?vue&type=template&id=345f6e58&scoped=true&"
import script from "./Edit-User.vue?vue&type=script&lang=js&"
export * from "./Edit-User.vue?vue&type=script&lang=js&"
import style0 from "./Edit-User.vue?vue&type=style&index=0&id=345f6e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f6e58",
  null
  
)

export default component.exports